export const ReviewSortCategories = {
  HIGHEST_RATED: 'HIGHEST_RATED',
  LOWEST_RATED: 'LOWEST_RATED',
  MOST_RECENT: 'MOST_RECENT',
};
